// Chakra imports
import {
  Box,
  Flex,
  Text,
  Icon,
  Checkbox,
  useColorModeValue,
  IconButton,
  Input,
  Button,
  Stack,
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
import { MdCheckBox, MdDragIndicator, MdDelete, MdAdd } from "react-icons/md";
import React, { useState } from "react";

export default function Tasks() {
  const [tasks, setTasks] = useState([]);
  const [newTask, setNewTask] = useState('');

  const handleDelete = (id) => {
    setTasks(tasks.filter(task => task.id !== id));
  };

  const toggleTask = (id) => {
    setTasks(tasks.map(task => task.id === id ? {...task, completed: !task.completed} : task));
  };

  const addTask = () => {
    if (newTask.trim()) {
      setTasks([...tasks, { id: tasks.length + 1, text: newTask, completed: false }]);
      setNewTask('');
    }
  };

  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "navy.700");
  const brandColor = useColorModeValue("brand.500", "brand.400");

  return (
    <Card p='20px' align='center' direction='column' w='100%'>
      <Flex alignItems='center' w='100%' mb='30px'>
        <Text color={textColor} fontSize='lg' fontWeight='700'>
          Tasks
        </Text>
      </Flex>
      <Box px='11px'>
        {tasks.map(task => (
          <Flex key={task.id} mb='20px'>
            <Checkbox
              me='16px'
              isChecked={task.completed}
              onChange={() => toggleTask(task.id)}
              colorScheme='brandScheme'
            />
            <Text
              fontWeight='bold'
              color={textColor}
              fontSize='md'
              textAlign='start'
              flex='1'
              textDecoration={task.completed ? 'line-through' : 'none'}
            >
              {task.text}
            </Text>
            <IconButton
              icon={<MdDelete />}
              onClick={() => handleDelete(task.id)}
              colorScheme='red'
              size='sm'
              aria-label='Delete task'
            />
          </Flex>
        ))}
        <Stack direction='row' mb='20px'>
          <Input
            placeholder='Add new task'
            value={newTask}
            onChange={(e) => setNewTask(e.target.value)}
            size='sm'
          />
          <Button onClick={addTask} leftIcon={<MdAdd />} colorScheme='teal' size='sm'>
            Add
          </Button>
        </Stack>
      </Box>
    </Card>
  );
}
